import { FileTextOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';

import { useState } from 'react';

import { Card, Space, Typography, Modal, Button } from 'antd';

import * as Constants from '../../constants';
import { DownloadViaLink } from '../../clientUtils';

const { Text, Link } = Typography;

const { confirm } = Modal;

const DocumentCard = ({ link, name, handleRemove, file, deleteDisabled = false }) => {
  const [mouseOver, setMouseOver] = useState(false);

  const onMouseEnter = () => setMouseOver(true);
  const onMouseLeave = () => setMouseOver(false);

  const showDeleteConfirm = () => {
    confirm({
      title: 'Delete File',
      icon: <DeleteOutlined className="light-red" />,
      className: 'delete-confirmation-modal',
      content: 'All the file data will be lost. Are you sure you want to delete the file? ',
      onOk() {
        if (file) handleRemove(file);
      },
      okText: 'Delete'
    });
  };

  const handleDownload = (event) => {
    event.preventDefault();
    if (!link) return;
    DownloadViaLink(link, name || link.split('/').pop()?.split('?')[0]);
  };

  return (
    <Card
      className="center"
      hoverable
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={Constants.STYLES.CARD}>
      <Space align="center" direction="vertical">
        {!mouseOver && <FileTextOutlined style={Constants.STYLES.ICON} />}
        {!!mouseOver && (
          <Space align="center" size="large">
            <Link className="accent-color" href={link} onClick={handleDownload}>
              <DownloadOutlined style={Constants.STYLES.ICON} />
            </Link>
            {handleRemove && file ? (
              <Button
                disabled={deleteDisabled}
                icon={
                  <DeleteOutlined
                    className={deleteDisabled ? 'light-red-disabled' : 'light-red'}
                    style={{ fontSize: 22 }}
                  />
                }
                onClick={showDeleteConfirm}
                type="link"
              />
            ) : null}
          </Space>
        )}
        <Text ellipsis style={Constants.STYLES.TEXT}>
          {name}
        </Text>
      </Space>
    </Card>
  );
};

export default DocumentCard;
